import {createRouter, createWebHistory} from "vue-router";
import home from '@/views/home.vue';
import count1 from "@/views/count1.vue";
import count2 from "@/views/count2.vue";
import adjustment from "@/views/adjustment.vue";
import detail from "@/views/detail.vue";
import login from "@/views/login.vue";
import Otp from "@/views/otp.vue";
import inform from "@/views/inform.vue";
import confirm from "@/views/confirm.vue";
import pay from "@/views/pay.vue";
import complete from '@/views/complete.vue';
import register from '@/views/register.vue';
import upload from "@/views/upload.vue";
import upload_complete from "@/views/upload_complete.vue";
import birthday from "@/views/birthday.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: home,
    },
    {
        path: '/count1',
        name: 'count1',
        component: count1
    },
    {
        path: '/count2',
        name: 'count2',
        component: count2
    },
    {
        path: '/adjustment',
        name: 'adjustment',
        component: adjustment
    },
    {
        path: '/detail',
        name: 'detail',
        component: detail
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/register',
        name: 'register',
        component: register,
        //meta: { requiresAuth: true }
    },
    {
        path: '/otp',
        name: 'otp',
        component: Otp,
    },
    {
        path: '/birthday',
        name: 'birthday',
        component: birthday,
        meta: {requiresAuth: true},
    },
    {
        path: '/inform',
        name: 'inform',
        component: inform,
    },
    {
        path: '/confirm',
        name: 'confirm',
        component: confirm,
    },
    {
        path: '/pay',
        name: 'pay',
        component: pay,
        meta: {requiresAuth: true, allowBack: false},
    },
    {
        path: '/complete',
        name: 'complete',
        component: complete,
        meta: { requiresAuth: true,allowBack: false}
    },
    {
        path: '/upload',
        name: 'upload',
        component: upload,
    },
    {
        path: '/upload_complete',
        name: 'upload_complete',
        component: upload_complete,
    },
    { //防止空白頁面進入
        path: '/:catchAll(.*)',
        redirect: '/'
    }
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    // eslint-disable-next-line no-unused-vars
    scrollBehavior(to, from, savedPosition) {
        let returnObject = {};

        if (to.hash) {
            returnObject = {
                el: to.hash,
                behavior: 'smooth',
            };
        } else {
            returnObject = {
                top: 0
            }
        }


        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(returnObject)
            }, 100)
        });
    }
})
router.beforeEach((to,from,next) =>{
    if (to.meta.allowBack != null) {
        if (!to.meta.allowBack) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', function () {
                history.pushState(null, null, document.URL);
            });
        } else {
            next();
        }
    }
    if (to.fullPath.substr(0,3) === "/#/") {
        const path = to.fullPath.substr(3);
        next(path);
        return;
    }
    next();
});

export default router

